import { InfoPanelType } from '@grays-npm/component-library';
import { APIListingNotificationType } from '../types';

/**
 * Maps over an API Listing's notification type and converts into @reference {InfoPanelType}
 */
export function mapListingNotificationType(
  notificationType: APIListingNotificationType
): InfoPanelType {
  switch (notificationType) {
    case 'Important':
      return 'important';
    case 'Success':
      return 'success';
    case 'Info':
    default:
      return 'info';
  }
}
